/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}split-button`;
const attributes = {
    VARIANT: 'variant',
    THEME: 'theme',
    DISABLED: 'disabled',
    DENSE: 'dense',
    PILL: 'pill'
};
const defaults = {
    DEFAULT_VARIANT: 'text',
    DEFAULT_THEME: 'primary'
};
export const SPLIT_BUTTON_CONSTANTS = {
    elementName,
    attributes,
    defaults
};
